import { render, staticRenderFns } from "./BjLogin.vue?vue&type=template&id=57def139&scoped=true&"
import script from "./BjLogin.vue?vue&type=script&lang=js&"
export * from "./BjLogin.vue?vue&type=script&lang=js&"
import style0 from "./BjLogin.vue?vue&type=style&index=0&id=57def139&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57def139",
  null
  
)

export default component.exports